document.querySelectorAll(".open-size-popup").forEach((button) => {
  button.addEventListener("click", function (event) {
    event.stopPropagation(); // Prevent event bubbling
    let productId = this.getAttribute("data-product-id");
    let popup = document.querySelector(`[data-size-popup='${productId}']`);

    // Close any other open popups first
    document.querySelectorAll(".size-popup").forEach((p) => {
      p.style.display = "none";
      this.closest(".open-size-popup").style.display = "block";     
    });

    // Ensure popup is visible before measuring its width
    popup.style.display = "block";
    button.style.display = "none";
  });
});

document.querySelectorAll(".size-popup-close").forEach((closeBtn) => {
  closeBtn.addEventListener("click", function () {    
    this.closest(".size-popup").style.display = "none";   
    let csProductId = this.getAttribute("data-size-popup-cs");
    let csPopup = document.querySelector(`.open-size-popup[data-product-id='${csProductId}']`);
    csPopup.style.display = "flex"; 
    document.querySelector("body").classList.remove("custom-size-popup-opened");
  });
});

document.querySelectorAll(".open-complete-the-look-popup").forEach((button) => {
  button.addEventListener("click", function (event) { 
    event.stopPropagation(); // Prevent event bubbling
    let productId = this.getAttribute("data-popup");
    let popup = document.querySelector(`[data-cs-popup='${productId}']`);

    // Close any other open popups first
    document.querySelectorAll(".cart-cs-popup").forEach((p) => {
      p.style.display = "none";  
    });

    // Ensure popup is visible before measuring its width
    popup.style.display = "block";
    popup.style.visibility = "hidden"; // Prevent flickering while positioning
    popup.style.opacity = "0";
    document.querySelector("body").classList.add("custom-size-popup-opened");

    // Get button position and screen width
    let rect = document.querySelector("form[action='/cart']").getBoundingClientRect();
    let popupWidth = popup.offsetWidth || 200; // Default width if not yet calculated
    let screenWidth = window.innerWidth;
    let spaceOnRight = screenWidth - rect.right;
    let spaceOnLeft = rect.left;

    // Default: Align popup to the center
    let leftPosition = ''+(((spaceOnRight - popupWidth) / 2) - 10)+'px';
    popup.style.left = leftPosition;
    popup.style.transform = `translateY(-50%)`;

    // If there's not enough space on the left, align popup to the left of the button
    if (spaceOnRight < popupWidth) {    
      popup.style.left = `50%`;
      popup.style.transform = `translate(-50%,-50%)`;
    }

    // Show popup properly
    popup.style.visibility = "visible";
    popup.style.opacity = "1";
  });
});

// Close Popup when clicking "X"
document.querySelectorAll(".popup-close").forEach((closeBtn) => {
  closeBtn.addEventListener("click", function () {
    this.closest(".cart-cs-popup").style.display = "none";
    document.querySelector("body").classList.remove("custom-size-popup-opened");
  });
});

// Close Popup when clicking outside
document.addEventListener("click", function (event) {
  document.querySelectorAll(".cart-cs-popup").forEach((popup) => {
    if (
      !popup.contains(event.target) &&
      !event.target.matches(".open-complete-the-look-popup")
    ) {
      popup.style.display = "none";
      document.querySelector("body").classList.remove("custom-size-popup-opened");
    }
  });
});

// Select all product forms
document.querySelectorAll(".cart-cs-popup form").forEach((form) => {
  form.querySelectorAll(".variant-radio").forEach((radio) => {
    radio.addEventListener("click", function () {
      let selectedVariantId = this.getAttribute("data-variant-id");
      let hiddenInput = form.querySelector(".selected-variant");
      let submitButton = form.querySelector("button[type='submit']");

      // If the same radio button is clicked again, trigger form submit
      if (hiddenInput.value === selectedVariantId) {
        submitButton.click();
      } else {
        hiddenInput.value = selectedVariantId;
      }
    });
    // Also trigger submit when changing selection
    radio.addEventListener("change", function () {
      let selectedVariantId = this.getAttribute("data-variant-id");
      form.querySelector(".selected-variant").value = selectedVariantId;
      form.querySelector("button[type='submit']").click();
    });
  });
});

document.querySelectorAll(".cart-cs-popup form button").forEach((button) => {
  button.addEventListener("click", function (event) {
    event.preventDefault();
    let formElement = this.closest("form");

    fetch("/cart/add.js", {
      method: "POST",
      body: new FormData(formElement),
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((error) => Promise.reject(error));
        }
        return response.json();
      })
      .then((item) => {
        location.reload();
      })
      .catch((error) => {
        let errorMessage =
          error.description || "There was an error adding the product.";
        alert(errorMessage);
      });
  });
});